module.exports = __webpack_public_path__ + "39b9e90880c66e878e5d11445dfa5079.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1/public/team/Leadership_AlexP_0.jpg
// module id = 447
// module chunks = 0